import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-hoc-access-denied',
  templateUrl: './hoc-access-denied.component.html',
  styleUrls: ['./hoc-access-denied.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HocAccessDeniedComponent {}
